import { TnEngineContext, TnEngineExtraContext } from "pytha";
import { BimBaseContext } from "tnbimbase";

class GraphicStore {
    context: TnEngineContext; // 核心库上下文
    extraContext: TnEngineExtraContext; // 扩展库上下文
    bimContext: BimBaseContext; // 专业几何库上下文
}

export const graphicStore = new GraphicStore();  